import { LangCodeType, LangDirType, languages } from "./sharedDataConstants";

export const englishLanguageCode = "en";

/**
 * This function takes a language ISO code and return the text direction
 * for that language as whether it's RTL or LTR
 * @param code
 * @returns
 */
export const getLangDir = (code?: LangCodeType): LangDirType => {
  if (!code) {
    return "ltr";
  }
  const userLang = languages.find(
    (lang) => lang.code.toLowerCase() === code.toLowerCase()
  );
  return (userLang?.dir || "ltr") as LangDirType;
};

export type { LangCodeType, LangDirType };
